import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { WidgetDescriptionDialog } from '../../../store-portal/components/dialogs/widget-description-dialog.component';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';

@Component({
    selector: 'hoWid005',
    templateUrl: 'src/app/features/head-office-portal/widgets/templates/wid-005.html',
    standalone: false
})
export class HoWid005 {
    public captions: any;
    public isTimedOut: boolean = false;
    public areDatapointsInvalid: boolean = true;
    public invalidDatapoints: any[] = [];
    public datapoints: any[] = [];

    public headers: string[];
    public labels: string[];
    public datasets: any[];

    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage
    ) {
        this.captions = this.captionService.captions;
        this.headers = [this.captions.prodDesc, this.captions.netTotalFront];
        if (this.widget?.id) {
            this.datapoints = this.browserStorage.getSessionstorage(this.widget.id, null);
        }
    }
    
    openInfoDialog() {
        this.dialog.open(WidgetDescriptionDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            data: {
                widgetID: 'ho-' + this.widget.id,
            },
        });
    }
    
    ngOnInit() {
        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        // Verify datapoints, making sure they are not null or undefined
        this.areDatapointsInvalid = false;
        for (let i = 0; i < this.widget.data.length; i++) {
            if (!this.widget.data[i]) {
                this.areDatapointsInvalid = true;
                this.invalidDatapoints.push(this.datapoints[i]);
            }
        }
        if (this.areDatapointsInvalid) {
            return;
        }
        
        let salesData = this.widget.data[0].Record;
        if (!salesData) {
            this.labels = [];
            this.datasets = [];
            return;
        }

        let labels = [],
            dataset = [];
        salesData = Array.isArray(salesData) ? salesData : [salesData];
        salesData.forEach((item) => {
            if (item.PRODUCT === '[OTHER]') {
                item.PRODUCT = this.captions.other;
            }
            labels.push(item.PRODUCT);
            dataset.push(item.VALUEWITHTAX.toFixed(2));
        });
        this.labels = labels;
        this.datasets = [{ data: dataset }];
    }
}